<template lang="pug">
  .mercado-pago
    p.mercado-pago__information
      | Faça sua conta #[b.bold Mercado Pago] grátis e #[b.bold pague em até 12x sem juros]

    .mercado-pago__wrapper
      .mercado-pago__benefits
        img.mercado-pago__benefits__icon(src='@/assets/icons/seguranca-mercado-pago.svg')
        .mercado-pago__benefits__content
          span.mercado-pago__benefits__title Proteção
          span.mercado-pago__benefits__descripition Seus dados sempre seguros
      .mercado-pago__benefits
        img.mercado-pago__benefits__icon(src='@/assets/icons/onetouch-mercado-pago.svg')
        .mercado-pago__benefits__content
          span.mercado-pago__benefits__title One Touch
          span.mercado-pago__benefits__descripition Pague com 1 clique

    p Ao clicar abaixo você será direcionado ao Mercado Pago para realizar o pagamento
</template>

<script>
import views from '@/mixins/views'

export default {
  name: 'MercadoPago',
  mixins: [views],
  data () {
    return {
      isPaymentsClient: false
    }
  },
  mounted () {
    this.injectMercadoPagoScript()

    this.$emit('outinput', {
      installment: 1,
      isValid: true
    })
  },
  methods: {
    injectMercadoPagoScript () {
      if (document.getElementsByClassName('MPScript').length === 0 || this.scriptErrorList.length > 0) {
        const elScript = document.createElement('script')
        elScript.setAttribute('src', 'https://sdk.mercadopago.com/js/v2')
        elScript.setAttribute('async', true)
        elScript.setAttribute('defer', true)
        elScript.setAttribute('class', 'MPScript')
        document.head.appendChild(elScript)
        this.isPaymentsClient = true
      }
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/style/_variables";

  .mercado-pago {
    color: #716E82;

    &__information {
      color: #716E82;
      font-family: $rubik-font-family;
      font-size: 16px;
      font-weight: normal;
      margin-top: 22px;

      @media screen and (min-width: 768px) {
        margin-top: 26px;
      }
    }

    &__wrapper {
      display: flex;
      flex-flow: wrap;
      margin-bottom: 32px;
      margin-top: 32px;
    }
  }

  .mercado-pago__benefits {
    align-items: center;
    display: flex;
    margin-left: -12px;
    margin-top: 16px;

    &__icon {
      height: 56px;
      width: 56px;
    }

    &__content {
      display: flex;
      flex-direction: column;
      font-family: $rubik-font-family;
      margin-left: 16px;
    }

    &__title {
      color: #636D7A;
      font-size: 18px;
      font-weight: 500;
      height: 22px;
      margin-bottom: 8px;
      width: 230px;
    }

    &__descripition {
      color: #595959;
      font-size: 14px;
      height: 17px;
      width: 230px;
    }
  }
</style>
